<script lang="ts">
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	const min = 0,
		max = 50;
	let value = settings[get_gen_2_component_channel_structure(device)].motor.idle_power_thr,
		loading = false;

	$: disabled = value < min || value > max;

	const changePowerThr = async () => {
		loading = true;
		const res = await gen2Request(device, `${get_gen_2_component_from_category(device)}.SetConfig`, {
			id: device.channel,
			config: { motor: { idle_power_thr: value } },
		});
		if (res.isok) {
			settings[get_gen_2_component_channel_structure(device)].motor.idle_power_thr = value;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
		} else if (res?.errors?.message) {
			toast.open({ type: 'danger', title: res?.errors?.message });
		} else {
			toast.open({ type: 'danger', title: $format('setting_err_toast') });
		}
		loading = false;
	};
</script>

<Text class="mb-s" styleType="body-small">
	{$format('power_threshold_descr_cover', {
		default: `Threshold (in Watts) below which the motor is considered stopped. Values ${min}-${max}W.`,
		values: { min, max },
	})}
</Text>

<Input
	size="m"
	class="mb-s"
	{min}
	{max}
	type={'number'}
	bind:value
	id="input-wxdkgyl"
	aria-label={$format('power_threshold_descr_cover', {
		default: `Threshold (in Watts) below which the motor is considered stopped. Values ${min}-${max}W.`,
		values: { min, max },
	})}
/>
<Button {disabled} {loading} size="m" width="full" on:click={changePowerThr}
	>{$format('button_save')}</Button
>
